//Built-in libraries

//Third party libraries

//Custom components
import Button from "components/UI/Button";
import { HookInput } from "components/UI/HookForm/Form/Input";
import { HookSelect } from "components/UI/HookForm/Form/Select";
import HookMaskedInput from "components/UI/HookForm/Form/MaskedInput";

//Services
import { useApplicationFormContext } from "features/ApplicationForm/ApplicationFormProvider";

//STP Libraries

//Assets and Miscellaneous
import { States } from "../../../../../../constants";
import { gender, maritalStatus, races } from "./constants";
import { HookRadioGroup } from "components/UI/HookForm/Form/RadioGroup";
import { HookCheckboxGroup } from "components/UI/HookForm/Form/CheckBoxGroup";

//Component Begin

export default function Application() {
  const { setCurrentStep } = useApplicationFormContext();

  return (
    <div className="p-6 space-y-6 sm:rounded-r-md sm:overflow-hidden">
      <div>
        <h3 className="text-lg leading-6 font-medium text-primaryColor-normal">
          Application Information
        </h3>
      </div>
      <div className="grid grid-cols-6 gap-6">
        <HookInput
          customClassName="col-span-2"
          label="Name"
          name="application.name"
          type="text"
        />
        <HookInput
          customClassName="col-span-4"
          label="Current Address"
          name="application.streetAddress"
          type="text"
        />
        <HookInput
          customClassName="col-span-6 sm:col-span-6 lg:col-span-2"
          label="City"
          name="application.city"
          type="text"
          disabled
        />

        <HookSelect
          customClassName="col-span-6 sm:col-span-3 lg:col-span-2"
          label="State"
          disabled
          name="application.state"
          options={States.map((s) => ({ label: s.name, value: s.name }))}
        />

        <HookInput
          customClassName="col-span-6 sm:col-span-3 lg:col-span-2"
          label="Zip / Postal Code"
          name="application.zipCode"
          type="number"
        />
        <HookMaskedInput
          customClassName="col-span-2"
          label="Home Phone"
          name="application.homePhone"
          maskedComponent="phone"
        />
        <HookMaskedInput
          customClassName="col-span-2"
          label="Work Phone"
          name="application.workPhone"
          maskedComponent="phone"
        />
        <HookMaskedInput
          customClassName="col-span-2"
          label="Cell/Other Phone"
          name="application.otherPhone"
          maskedComponent="phone"
        />
        <HookInput
          customClassName="col-span-6 sm:col-span-3 lg:col-span-2"
          label="Date of Birth"
          name="application.dob"
          type="date"
        />
        <HookInput
          customClassName="col-span-6 sm:col-span-3 lg:col-span-2"
          label="Last Four of Social"
          name="application.lastFourSocial"
          type="text"
        />

        <HookRadioGroup
          className="col-span-6"
          label="Gender"
          name="application.gender"
          id="application.gender"
          options={gender.map((d) => {
            return { label: d, value: d };
          })}
        />
        <HookRadioGroup
          className="col-span-6"
          label="Marital Status"
          name="application.maritalStatus"
          id="application.maritalStatus"
          options={maritalStatus.map((d) => {
            return { label: d, value: d };
          })}
        />
        <HookRadioGroup
          className="col-span-6"
          label="Disabled"
          name="application.disabled"
          id="application.disabled"
          options={[
            { label: "Yes", value: "yes" },
            { label: "No", value: "no" },
          ]}
        />
        <HookRadioGroup
          className="col-span-6"
          label="Are you a city Employee ?"
          name="application.cityEmployee"
          id="application.cityEmployee"
          options={[
            { label: "Yes", value: "yes" },
            { label: "No", value: "no" },
          ]}
        />
        <div className="col-span-6">
          <HookCheckboxGroup
            label="Race"
            name="application.races"
            options={races.map((p) => ({
              label: p,
              value: p,
            }))}
          />
        </div>
      </div>
      <div className="flex gap-4 justify-end mt-5">
        <Button
          label="Previous"
          btnStyle="neutral"
          type="button"
          onClick={() => setCurrentStep((prev) => prev - 1)}
        />
        <Button label="Next" btnStyle="primary" type="submit" />
      </div>
    </div>
  );
}
